<template>
  <div>
    <generic-table
      ref="datatable"
      :title="$t('branches')"
      :columns="columns"
      :column_search="true"
      resource_url="/branch/datatables"
      mode="grid"
      grid_class="is-col-min-10"
      :page_length="50"
    >
      <template v-slot:buttons>
        <button class="button is-secondary is-rounded" @click="create">
          <span class="icon"><i class="fa fa-plus"></i></span>
          <span>{{ $t("add") }}</span>
        </button>
      </template>
      <template #item="item">
        <div class="card">
          <div class="card-image">
            <!-- <div
              class="is-pulled-right has-text-danger"
              :data-tooltip="$t('delete')"
              @click="remove(item)"
            >
              <span class="icon"><i class="fa fa-trash"></i></span>
            </div> -->
            <!-- <div
              class="is-pulled-right has-text-warning"
              :data-tooltip="$t('edit')"
              @click="edit(item)"
            >
              <span class="icon"><i class="fa fa-edit"></i></span>
            </div> -->
            <figure class="image is-64x64 m-auto">
              <img
                src="https://cdn-icons-png.freepik.com/256/6980/6980735.png"
              />
            </figure>
          </div>
          <div class="card-content px-0">
            <div class="media">
              <div class="media-content has-text-centered">
                <p class="title is-4">{{ item.name }}</p>
                <p class="subtitle is-6 mb-0" v-show="item.address">
                  <span class="icon">
                    <i class="fa fa-map-marker"></i>
                  </span>
                  {{ item.address }}
                </p>
                <p class="subtitle is-6" v-show="item.phone">
                  <span class="icon">
                    <i class="fa fa-phone"></i>
                  </span>
                  {{ item.phone }}
                </p>

                <!-- <pre>{{ item }}</pre> -->
              </div>
            </div>
          </div>
          <footer class="card-footer" v-show="true">
            <a
              class="card-footer-item button"
              :data-tooltip="$t('edit')"
              @click="edit(item)"
            >
              <span class="icon"><i class="fa fa-edit"></i></span>
            </a>
            <a
              class="card-footer-item has-text-danger button"
              :data-tooltip="$t('delete')"
              @click="remove(item)"
            >
              <span class="icon"><i class="fa fa-trash"></i></span>
            </a>
          </footer>
        </div>
      </template>
    </generic-table>
  </div>

  <branch-modal ref="branch_modal" @success="refresh" />
</template>

<script>
// import GenericTable from "../../../../app/src/components/generic_table/GenericTable.vue";
import GenericTable from "@/components/generic_table/GenericTable.vue";
import {
  generate_datatables_buttons,
  confirm_deletion_dialog,
  del,
  error_message,
  format_currency,
} from "@/utils";
import BranchModal from "./branch_modal/Index.vue";

export default {
  name: "BranchDatatable",
  components: { GenericTable, BranchModal },
  data() {
    let v = this;
    return {
      columns: [
        {
          title: v.$t("data"),
          searchable: false,
          data: (row) => {
            return `<pre>${JSON.stringify(row, null, 2)}</pre>`;
            // return row.number || "";
          },
        },
      ],
    };
  },
  methods: {
    create() {
      let v = this;
      v.$refs.branch_modal.show_modal();
    },
    refresh() {
      let v = this;
      v.$refs.datatable.refresh();
    },
    edit(item) {
      let v = this;
      v.$refs.branch_modal.edit_modal(item.uuid);
    },
    remove(item) {
      let v = this;
      confirm_deletion_dialog(v.$t("are you sure to delete branch?"), v, () => {
        put("/branch", {})
          .then(() => {
            v.refresh();
          })
          .catch((error) => {
            error_message(error);
          });
      });
    },
  },
  mounted() {
    this.refresh();
  },
};
</script>

<style></style>
